import React, { useState } from 'react';
import './Tooltip.css';

export const Tooltip = (props:any) => {
  let timeout:any;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className={props.id === 'exportJob' ? 'Tooltip-Wrapper-Export' : 'Tooltip-Wrapper'}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || 'top'}`} title={props.content}>
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
